export const isInViewport = (elem: Element) => {
  const bounding = elem.getBoundingClientRect();

  if (bounding.width === 0 && bounding.height === 0) {
    return false
  }

  return (
    bounding.top >= 0 &&
    bounding.left >= 0 &&
    bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
  )
}

export const isCrossingRightSideOfViewport = (elem: Element) => {
  const bounding = elem.getBoundingClientRect();

  if (bounding.width === 0 && bounding.height === 0) {
    return false
  }

  return (
    bounding.right > (window.innerWidth || document.documentElement.clientWidth)
  )
}
